/**
 * https://decipher.dev/30-seconds-of-typescript/docs/omit/
 *
 * ```
 * omit({ a: 1, b: "2", c: 3 }, ["b"]); // { 'a': 1, 'c': 3 }
 * ```
 */
var omit = function (obj, arr) {
    return Object.keys(obj)
        .filter(function (k) { return !arr.includes(k); })
        .reduce(function (acc, key) {
        acc[key] = obj[key];
        return acc;
    }, {});
};
export default omit;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib21pdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb3JlL3V0aWxzL2xvZGFzaC9vbWl0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBOzs7Ozs7R0FNRztBQUNILElBQU0sSUFBSSxHQUFHLFVBQ1gsR0FBTSxFQUNOLEdBQU07SUFFTixPQUFPLE1BQU0sQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDO1NBQ3BCLE1BQU0sQ0FBQyxVQUFDLENBQUMsSUFBSyxPQUFBLENBQUMsR0FBRyxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsRUFBaEIsQ0FBZ0IsQ0FBQztTQUMvQixNQUFNLENBQUMsVUFBQyxHQUFHLEVBQUUsR0FBRztRQUNmLEdBQUcsQ0FBQyxHQUFHLENBQUMsR0FBRyxHQUFHLENBQUMsR0FBRyxDQUFDLENBQUM7UUFDcEIsT0FBTyxHQUFHLENBQUM7SUFDYixDQUFDLEVBQUUsRUFBUyxDQUFDLENBQUM7QUFDbEIsQ0FBQyxDQUFDO0FBRUYsZUFBZSxJQUFJLENBQUMifQ==